<template>
  <v-ons-pull-hook :modifier="$mdModifier" :action="pullHookOnAction" height="100" threshold-height="200" :fixed-content="$md"
                   :on-pull="$md && pullHookOnPull || null" @changestate="pullHookState = $event.state" :disabled="pullHookState === 'action'">
    <!-- iOS -->
    <v-ons-icon v-if="!$md" class="pull-hook-spinner" size="22px" :icon="pullHookState === 'action' ? 'fa-spinner' : 'fa-arrow-down'"
                :rotate="pullHookState === 'preaction' && 180" :spin="pullHookState === 'action'"></v-ons-icon>
    <!-- Material -->
    <div v-else class="pull-hook-progress">
      <v-ons-progress-circular modifier="material" :value="pullHookRatio * 100" :indeterminate="pullHookState === 'action'"></v-ons-progress-circular>
    </div>
  </v-ons-pull-hook>
</template>

<script>
export default {
  data() {
    return {
      pullHookState: 'initial',
      pullHookRatio: 0
    }
  },
  methods: {
    pullHookOnPull(ratio) {
      this.pullHookRatio = ratio;
    },
    pullHookOnAction(done) {
      this.$emit('call-api', {
        done: done
      });
    }
  }
}
</script>

<style>
.pull-hook-spinner {
  color: #666;
  /* transition: transform 0.25s ease-in-out; */
}
.pull-hook-progress {
  background-color: white;
  width: 32px;
  height: 32px;
  margin: 30px auto 0;
  border-radius: 100%;
  position: relative;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  display: inline-block;
  line-height: 0px;
}
.pull-hook-progress .progress-circular {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 4px;
  left: 4px;
}
.pull-hook-progress .progress-circular__primary {
  transition: stroke-dashoffset 0s;
}
</style>
